import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, inject, input, viewChild } from "@angular/core";
import { NotificationService } from "../../../../core-ui/services/notification.service";
import { copyTextToClipboard } from "../../../../core-ui/services/utils";

@Component({
  selector: "av-copy-clipboard",
  templateUrl: "./copy-clipboard.component.html",
  styleUrls: ["./copy-clipboard.component.scss"],
  standalone: false,
})
export class CopyClipboardComponent implements OnInit {
  private notification = inject(NotificationService);

  readonly url = input<string>(undefined);
  readonly tooltipLabel = input("Copy download link");
  readonly tooltipPosition = input<"top" | "bottom" | "left" | "right">("top");
  readonly size = input<"xs" | "sm" | "xxs" | "md">("sm");
  readonly tid = input<string>(undefined);

  readonly buttonRef = viewChild("btnRef", { read: ElementRef });

  shouldFocus = false;

  ngOnInit(): void {}

  copy() {
    copyTextToClipboard(this.url());
    this.notification.info("Copied to clipboard");
  }

  focus() {
    this.buttonRef().nativeElement.focus();
  }
}
